import {Container} from "../ui-components/Container";

const BottomBar = ({ children }) => (
  <div className="z-50 bg-white sticky bottom-0 left-0 right-0 border-t">
    <Container>
      {children}
    </Container>
  </div>
)

export default BottomBar;